(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58],{

/***/ 47950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshmark-prohibited-items/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-10-19",
      tag: "Poshmark",
      title: "What NOT to sell on Poshmark - Poshmark`s Prohibited Items",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The categories allowed on Poshmark are straightforward:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Clothing and accessories for Women, Kids, and Men"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Brand new and unused personal care items"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select home goods and pet items"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You may consider other online marketplaces, such as Mercari, where you can list products that don't fall under these categories. Doing so will enable you to target the right market, and at the same time, you get to keep your seller integrity on Poshmark.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why does Poshmark prohibit certain items? "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark prohibits certain items primarily for two reasons: first is to provide a seamless browsing experience for buyers and make room only for relevant items that fit in the authorized categories. Second, to work in compliance with its shipping partner and regulatory bodies to ensure that laws, statutes, and ordinances are observed on its selling platform.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What are the consequences of selling a prohibited item on Poshmark? "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark reserves the right to take the necessary action it deems fitting to the gravity of the offense committed by the errant seller. Once a listing gets flagged or reported, Poshmark will immediately delete it. The platform will then conduct an investigation on the case before they decide to either suspend or delete the seller's account."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When an account gets suspended, activities within the marketplace, including the PoshCredits options, are temporarily disabled and may only be revived once the seller reaches out to Poshmark to appeal for account reactivation. On the other hand, when Poshmark deletes an account, it is equivalent to permanent suspension with no chance of recovery.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What items are prohibited on Poshmark?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Below is a list of some of the distinct items not allowed on Poshmark according to its prohibited items policy. It's important to note that this list is not comprehensive and only serves to illustrate in general what is considered illicit on the platform. Dangerous products that are illegal to sell in person are not allowed on Poshmark.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If strongly in doubt about a product, it would be advisable to err on the side of safety and forego listing it in your closet.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Replicas and fakes"
          }), " \u2013 Counterfeits in all shapes and sizes \u2013 and regardless if the seller is aware of a product's inauthenticity or not -- are not acceptable.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "\"Inspired by\" goods"
          }), " \u2013 Any product that infringes a copyright or brand name is prohibited. A popular example of this includes \"reworked\" clothing or jewelry that features parts (including monogrammed fabric, embossed button, or other similar embellishments) of a designer item to pass it off as a luxury or limited-edition goods. This practice may be considered a violation of the trademark law.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Aerosols, perfumes, nail polish, and anything with Lithium batteries"
          }), " \u2013 Any item included under the goods USPS classified as restricted for domestic shipping is prohibited. If listing brand new personal care products like lotion, ensure that it comes with its original seal, is alcohol-free, aerosol-free, and does not contain any flammable component. Note that Poshmark can only sell what is allowed to be shipped according to the shipping label type they use. Refer to the USPS website for a full list of what you cannot transport according to regulations."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Certain electronics"
          }), " \u2013 Although Poshmark doesn't prohibit the selling of electronics, they are not explicitly clear on which kinds of electronics are allowed to sell either. What's certain is that they don't allow cell phones, DVDs, and appliances. It may be safe to assume that Poshmark is not your best bet for selling electronic items."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Used makeup and underwear"
          }), " -- Preloved products in good condition are welcome on Poshmark, but not when it comes to personal and intimate items such as makeup and underwear. In listing these kinds of items, including photos that prove their pristine condition."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Health, wellness, and medical products"
          }), " \u2013 Items that promise good health, require a prescription, or boast medical claims, are not allowed. This category includes consumable wellness products like vitamins and supplements, such as protein powders and energy bars, and first aid supplies and equipment like breastmilk pumps and gears and slimming devices."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Food and live animals"
          }), " \u2013 Perishable products and live creatures are prohibited. Home d\xE9cor, clothing, and accessories made from threatened or endangered species identified by the Coalition to End Wildlife Trafficking Online are likewise not allowed."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Airline uniform and airline costumes"
          }), " \u2013 Any clothing and accessories that can potentially misrepresent airline crew or airport staff are considered prohibited."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Ready to take your Poshmark side hustle to the next level? Let OneShop's intelligent marketing automation features handle the time-consuming aspects of growing your business and focus on enriching your inventory with safe to sell, saleable listings. Try it for seven days, no credit card or commitment required!", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-prohibited-items.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "What NOT to sell on Poshmark - Poshmark's Prohibited Items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Prohibited items can get a seller's account suspended \u2013 or even deleted. Find out which ones belong to the no-go zone!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-prohibited-items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-prohibited-items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "What NOT to sell on Poshmark - Poshmark's Prohibited Items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Prohibited items can get a seller's account suspended \u2013 or even deleted. Find out which ones belong to the no-go zone!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-10-19T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-10-19T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 53906:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-prohibited-items",
      function () {
        return __webpack_require__(47950);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(53906); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);